import { FC, useEffect, useState } from "react";
import { KTSVG } from "../../_metronic/helpers";
import { useIntl } from "react-intl";
import { Role } from "../../interfaces/Role";
import { getDetailRole } from "../../api/RolesCRUD";
import Swal from "sweetalert2";
import useAccessToken from "../../hooks/AccessToken";

interface Props {
    data: Role
}

const DetailUserRole: FC<Props> = ({ data }) => {
    const intl = useIntl()
    const [loading, setLoading] = useState<boolean>(false)
    const [detailRole, setDetailRole] = useState<Role>()
    const token = useAccessToken()

    const getRole = async () => {
        setLoading(true)
        try {
            const response = await getDetailRole(data.id, token)
            if (response.data.success) {
                setDetailRole(response.data.data)
            }
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: error.response.data.message,
                confirmButtonText: 'Ok',
            })
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getRole()
    }, [])

    return (
        <>
            <div className="modal fade" tabIndex={-1} id={`detail-user-role-modal-${data.id}`}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Detail {intl.formatMessage({ id: 'FORM.LABEL.USER' })} {data.name}</h5>
                            <div
                                className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-2x"
                                />
                            </div>
                        </div>
                        {detailRole && !loading ?
                            <div className="modal-body">
                                <ol className="mb-0 lh-xl">
                                    {detailRole?.users.map((user) => 
                                        <li key={user.id}>
                                            {user.name}
                                        </li>
                                    )}
                                </ol>
                            </div>
                            :
                            <div className="modal-body" style={{ height: "200px" }}>
                                <div className="loading-overlay">
                                    <div className="loader"></div>
                                </div>
                            </div>
                        }
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light"
                                data-bs-dismiss="modal"
                            >
                                {intl.formatMessage({ id: 'FORM.ACTION.CLOSE' })}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export { DetailUserRole }